/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Position_X_Offset_TooltipInputs */

const en_style_guide_manager_position_x_offset_tooltip = /** @type {(inputs: Style_Guide_Manager_Position_X_Offset_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check for Events where the horizontal offset is set.`)
};

const fr_style_guide_manager_position_x_offset_tooltip = /** @type {(inputs: Style_Guide_Manager_Position_X_Offset_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifier les evenements ou le decalage horizontal est defini.`)
};

const de_style_guide_manager_position_x_offset_tooltip = /** @type {(inputs: Style_Guide_Manager_Position_X_Offset_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prüfen Sie, ob Ereignisse mit einem festgelegten horizontalen Versatz vorliegen.`)
};

const it_style_guide_manager_position_x_offset_tooltip = /** @type {(inputs: Style_Guide_Manager_Position_X_Offset_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controllare gli eventi in cui è impostato lo spostamento orizzontale.`)
};

const ru_style_guide_manager_position_x_offset_tooltip = /** @type {(inputs: Style_Guide_Manager_Position_X_Offset_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверьте события, в которых задано горизонтальное смещение.`)
};

const es_style_guide_manager_position_x_offset_tooltip = /** @type {(inputs: Style_Guide_Manager_Position_X_Offset_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprueba si hay eventos en los que esté establecido el desplazamiento horizontal.`)
};

const zh_cn2_style_guide_manager_position_x_offset_tooltip = /** @type {(inputs: Style_Guide_Manager_Position_X_Offset_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检查是否存在设置了水平偏移量的事件。`)
};

const ja_style_guide_manager_position_x_offset_tooltip = /** @type {(inputs: Style_Guide_Manager_Position_X_Offset_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`水平オフセットが設定されているイベントを確認します。`)
};

const hi_style_guide_manager_position_x_offset_tooltip = /** @type {(inputs: Style_Guide_Manager_Position_X_Offset_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उन इवेंट्स की जांच करें जहां हॉरिजॉन्टल ऑफसेट सेट किया गया है।`)
};

const pt_pt2_style_guide_manager_position_x_offset_tooltip = /** @type {(inputs: Style_Guide_Manager_Position_X_Offset_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifique os eventos em que o deslocamento horizontal está definido.`)
};

/**
* | output |
* | --- |
* | "Check for Events where the horizontal offset is set." |
*
* @param {Style_Guide_Manager_Position_X_Offset_TooltipInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_position_x_offset_tooltip = /** @type {((inputs?: Style_Guide_Manager_Position_X_Offset_TooltipInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Position_X_Offset_TooltipInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_position_x_offset_tooltip(inputs)
	if (locale === "de") return de_style_guide_manager_position_x_offset_tooltip(inputs)
	if (locale === "it") return it_style_guide_manager_position_x_offset_tooltip(inputs)
	if (locale === "ru") return ru_style_guide_manager_position_x_offset_tooltip(inputs)
	if (locale === "es") return es_style_guide_manager_position_x_offset_tooltip(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_position_x_offset_tooltip(inputs)
	if (locale === "ja") return ja_style_guide_manager_position_x_offset_tooltip(inputs)
	if (locale === "hi") return hi_style_guide_manager_position_x_offset_tooltip(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_position_x_offset_tooltip(inputs)
	return en_style_guide_manager_position_x_offset_tooltip(inputs)
});